<template>
    <el-card class="box-card" shadow="hover">
        <div slot="header" class="clearfix">
            <span>每日{{search.status==1 ? '登记' : '预约' }}来源人数 <small>(合计： 微信预约{{ total_weixin }}人, 团体预约{{ total_team }}人)</small></span>
            <el-form :inline="true" :model="form" style="float:right">
                <!-- <el-form-item label="预约日期">
                    <el-date-picker v-model="form.daterange" size="mini" type="daterange" range-separator="至"
                    style="width: 240px"
                        start-placeholder="开始日期" value-format="yyyy-MM-dd" end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item> -->
                <el-button style="padding: 3px 0" type="text" @click="getData" icon="el-icon-refresh"></el-button>
            </el-form>
        </div>
        <v-chart autoresize ref="chart" :option="option" style="height: 200px" v-loading="loading"></v-chart>
    </el-card>
</template>

<script>
export default {
    name: 'statAppointSourceDates',
    props: {
        search: {
            type: [Object],
            default: {}
        }
    },
    data() {
        return {
            loading: false,
            form: { daterange: [] },
            total_weixin: 0,
            total_team: 0,
            option: {
                grid: {
                    top: 40,
                    bottom: 20,
                    left: 50,
                    right: 15,
                },
                legend: {
                    left: 'center',
                    top: 'top',
                    data: ['微信预约', '团体预约']
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: '微信预约',
                        data: [],
                        type: 'bar',
                        itemStyle: {
                            color: '#1890ff'
                        }
                    },
                    {
                        name: '团体预约',
                        data: [],
                        type: 'bar',
                        itemStyle: {
                            color: '#de6e6a'
                        }
                    }
                ]
            }

        }
    },
    methods: {
        async getData() {
            this.loading = true
            const resp = await this.$http.get('/components/charts/statistics/appoint/sourcedates', {params: this.search})
            this.option.xAxis.data = []
            this.option.series[0].data = []
            this.option.series[1].data = []
            this.total_weixin = 0
            this.total_team = 0
            resp.data.forEach(e => {
                this.option.xAxis.data.push(e.date)
                this.option.series[0].data.push(e.weixin_count)
                this.option.series[1].data.push(e.team_count)
                this.total_weixin += e.weixin_count
                this.total_team += e.team_count
            })
            this.$refs['chart'].setOption(this.option)
            this.loading = false
        }
    },
    mounted() {
        this.getData().then(() => {
        })
    }
}
</script>
